import styled, { css } from 'styled-components'
import { colors } from 'const/colors'
import { Link } from 'react-router-dom'
import query from 'mediaQueries'
import { MenuActive } from 'typings/menu'
import {
  ActiveBorderCSS,
  ActiveSubMenuCSS,
  ExpandMenuCSS,
  MenuTextButtonCSS,
  MobileSubMenuItemCSS
} from './helpers'

export const MobileMenuListItem = styled.li`
  display: flex;
  flex-direction: column;
  margin: 0 0 16px;
`

export const MobileMenuItemsUl = styled.ul`
  margin: 0;
  padding: 0;
`

export const MobileMenuItemLi = styled.li`
  list-style-type: none;
`

export const MobileMenuItem = styled.div`
  display: flex;
  align-items: center;
  min-height: 32px;
`

export const MobileSubMenuItem = styled(props => <Link {...props} />)`
  text-decoration: none;
  font-size: 14px;
  margin: 0 0 0 15px;
  color: ${colors.greyTen};
  ${({ isParentLink }: MenuActive) => isParentLink && MobileSubMenuItemCSS}
`

export const MenuItem = styled.li`
  padding: 10px 8px 10px 35px;
  &:hover {
    background-color: ${colors.greyThirty};
    border-bottom: 2px solid ${({ theme }) => theme.menu.border};
  }
`

export const ActiveMobileBar = styled.div`
  width: 2px;
  height: 32px;
  background-color: ${colors.white};
  margin: 0 10px 0 0;
`

export const MobileMenuText = styled.span`
  font-size: 12px;
  color: ${colors.greyTen};
  text-transform: uppercase;
`

export const SubMenuItemContainer = styled.ul`
  display: none;
  position: absolute;
  background-color: ${colors.white};
  min-width: 180px;
  box-shadow: 0 1px 4px 0;
  padding: 12px 16px;
  z-index: 1;
  margin: 12px 0 0;
  left: 0;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  width: max-content;
  list-style-type: none;
  & li {
    display: block;
    padding: 10px;
  }
`

export const SubMenuItem = styled.li<{
  shouldExpand: boolean
  isActive: boolean
}>`
  position: relative;
  display: inline-block;
  padding: 10px 12px 10px 25px;
  ${({ isActive }: MenuActive) => isActive && ActiveSubMenuCSS}
  > ${SubMenuItemContainer} {
    display: ${({ shouldExpand }): string => (shouldExpand ? 'flex' : 'none')};
    flex-direction: column;
  }
  ${({ shouldExpand }) => shouldExpand && ExpandMenuCSS}
`

export const MenuTextButton = styled.button`
  color: ${colors.greyEighty};
  position: relative;
  text-decoration: none;
  border: none;
  background: none;
  font-size: 14px;
  cursor: pointer;
  padding-right: 0;
  padding-left: 0;
  @media ${query.lessThanSmall} {
    display: flex;
    align-items: center;
    margin: 5px 0;
  }

  ${({ isActive }: MenuActive) => isActive && MenuTextButtonCSS}
  ${SubMenuItem} & {
    padding-right: 13px;
  }
  ${SubMenuItem} &:after {
    content: '';
    border-width: 4px 4px 0 4px;
    border-color: ${colors.greyEighty} transparent;
    ${({ isActive }: MenuActive) => isActive && ActiveBorderCSS}
    border-style: solid;
    position: absolute;
    top: 9px;
    right: -2px;
  }
`

const getMenuLinkCSS = css`
  font-weight: 600;
  color: ${({ theme }) => theme.menu.text};
  ${MenuItem} &${MenuTextButton} {
    border-bottom: 2px solid ${({ theme }) => theme.menu.border};
    padding-bottom: 10px;
  }
`

export const MenuLink = styled(({ isActive, ...props }) => (
  <Link {...props} />
))<MenuActive>`
  text-decoration: none;
  color: ${colors.greyEighty};
  ${({ isActive }: MenuActive) => isActive && getMenuLinkCSS}
`

export const SubMenuText = styled.span`
  color: ${({ theme }) => theme.menu.text};
  font-weight: bold;
  position: relative;
`
